import { QuestionsSection } from '@/features/questionnaires/components';
import { Box } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { useQuestionnaireForm } from '@/features/questionnaires/hooks/useQuestionnaireForm';
import { FormWrapper, TextInput } from '@/shared';
import { DevTool } from '@hookform/devtools';

export const QuestionnairePage = ({ kind }: { kind: 'INITIAL' | 'EMA' }) => {
  const { t, goBack, ...form } = useQuestionnaireForm(kind);

  const translationKey =
    kind === 'INITIAL' ? 'initialQuestionnaire' : 'emaQuestionnaire';

  return (
    <FormWrapper
      form={form}
      title={t(`pages.studies.${translationKey}.create.title`)}
      description={t(`pages.studies.${translationKey}.create.description`)}
    >
      <FormProvider {...form}>
        <Box
          component="form"
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}
        >
          <TextInput
            form={form}
            name="title"
            label={t(`pages.studies.initialQuestionnaire.fields.title`)}
          />
          <QuestionsSection />
        </Box>
      </FormProvider>

      <DevTool control={form.control} />
    </FormWrapper>
  );
};
